module.exports = __webpack_public_path__ + "img/youhuiquan-logo.7745c953.png";